module.exports = __webpack_public_path__ + "static/header-image-default-745b4c6a054d4238457e5bb7856da5e7.jpg";